import { isNumber } from 'lodash';
/**
 * Format time function
 * Takes time in seconds and returns as formatted string
 * Examples:
 * 52    -> 52.00s
 * 60    -> 1m 0.00s
 * 65    -> 1m 5.00s
 * 65.89 -> 1m 5.89s
 * 65.80 -> 1m 6.80s
 *
 * @param seconds float
 * @returns {string}
 */
function formatTime(seconds) {
    const time = isNumber(seconds) ? seconds : 0;
    const integralValue = Math.floor(time / 60);
    const fractionalValue = (time % 60).toFixed(2);
    const integralPart = integralValue ? `${integralValue}m` : '';
    const fractionalPart = `${fractionalValue}s`;

    return (`${integralPart} ${fractionalPart}`).trim();
}

export default formatTime;



// WEBPACK FOOTER //
// ./src/js/utils/formatTime.js